import * as R from 'ramda';
import axios from 'axios';

import api, { hubApi } from './hub';
import { serializedBrandingUrl } from '../from-hub';

const unnest = R.path(['data', 'data']);

export const customBranding = () => {
  if (serializedBrandingUrl) {
    return axios.get(serializedBrandingUrl).then(R.prop('data'));
  }

  return axios.get('/api/branding').then(unnest);
};

export const getRecommendedChallenges = () => api.get('/carousel').then(R.pipe(
  R.prop('data'),
  ({ data, meta }) => ({
    challenges: data,
    orderedBy: meta.sort
  })
));

export const getFeatures = () => hubApi.get('/features').then(unnest);
